import { LocationVarKey, FMSLeadAddToAbandonedCartSequenceStrategy } from "@swivl-mono/types";

import { WorksheetColumn, WorksheetRow } from "../../../Components/Worksheets/Layout/Worksheet.Layout.Components";
import { IS_NOT_EQUAL } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  QuestDropdownRow,
  SectionHeader,
  SwitchRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export default function LocationSubpageHours() {
  const page = usePropertiesGetLocationIds();

  return (
    <>
      <SectionHeader {...page}> Subscription Information </SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <DropdownRow
            {...page}
            label="Tier"
            keyName={LocationVarKey.whichTier}
            options={[
              {
                label: "Engage",
                value: "Engage",
              },
              {
                label: "Foundation",
                value: "Foundation",
              },
              {
                label: "Innovator",
                value: "Innovator",
              },
              {
                label: "Disruptor",
                value: "Disruptor",
              },
            ]}
          />
          <InputRow {...page} keyName={LocationVarKey.SubscriptionMaxUsers} label="Max Users" />
          <SwitchRow {...page} keyName={LocationVarKey.AgentAssistEnabled} label="Agent Assist" />
          <SwitchRow {...page} keyName={LocationVarKey.SubscriptionEscalationSummary} label="Escalation History" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.HasReviewManager} label="Review Manager" />
          <SwitchRow {...page} keyName={LocationVarKey.HasSMSCampaigns} label="SMS Campaigns" />
          <SwitchRow {...page} keyName={LocationVarKey.swivlHasVoice} label="Voice" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Organization Settings </SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          {/* <SwitchRow {...page} keyName={LocationVarKey.FMSSyncEnabled} label="FMS Sync Enabled" /> */}
          <InputRow {...page} keyName={LocationVarKey.S3AnalyticsDir} label="S3 Analytics Directory" />
          <InputRow {...page} keyName={LocationVarKey.SpotBrandSlug} label="Spot Brand Slug" />
          <InputRow {...page} keyName={LocationVarKey.BrandImage} label="Brand Image" />
          <InputRow {...page} keyName={LocationVarKey.BrandColor} label="Brand Color" />
          <DropdownRow
            {...page}
            marginTop
            label=" Main FMS"
            keyName={LocationVarKey.WhichFMS}
            options={[
              {
                label: "Sitelink",
                value: "Sitelink",
              },
              {
                label: "StorEdge",
                value: "StorEdge",
              },
              {
                label: "Self Storage Manager",
                value: "SSM",
              },
              {
                label: "Tenant",
                value: "Tenant",
              },
              {
                label: "SSMCloud",
                value: "SSMCloud",
              },
              {
                label: "DoorSwap",
                value: "DoorSwap",
              },
              {
                label: "StorageMart",
                value: "StorageMart",
              },
              {
                label: "Cubby",
                value: "Cubby",
              },
              {
                label: "None",
                value: "None",
              },
            ]}
          />
        </WorksheetColumn>
        <WorksheetColumn>
          <DropdownRow
            {...page}
            marginTop
            label=" Main Country"
            keyName={LocationVarKey.DefaultCountry}
            options={[
              {
                label: "USA",
                value: "USA",
              },
              {
                label: "Canada",
                value: "Canada",
              },
              {
                label: "Mexico",
                value: "Mexico",
              },
              {
                label: "Australia",
                value: "Australia",
              },
              {
                label: "Ireland",
                value: "Ireland",
              },
              {
                label: "South Africa",
                value: "South Africa",
              },
            ]}
          />
          <DropdownRow
            {...page}
            marginTop
            label=" Measurement System"
            keyName={LocationVarKey.WhichMeasurementSystem}
            options={[
              {
                label: "Imperial",
                value: "Imperial",
              },
              {
                label: "Metric",
                value: "Metric",
              },
            ]}
          />
          <DropdownRow
            {...page}
            marginTop
            label=" Main Language"
            keyName={LocationVarKey.DefaultLanguage}
            options={[
              {
                label: "English",
                value: "English",
              },
              {
                label: "Spanish",
                value: "Spanish",
              },
              {
                label: "French",
                value: "French",
              },
            ]}
          />
          <DropdownRow
            {...page}
            marginTop
            label=" Persona"
            keyName={LocationVarKey.Persona}
            options={[
              {
                label: "Self Storage",
                value: "Self Storage",
              },
              {
                label: "RV Boat",
                value: "RV Boat",
              }
            ]}
          />
          <DropdownRow
            {...page}
            marginTop
            label=" Website Provider"
            keyName={LocationVarKey.WebsiteProvider}
            options={[
              {
                label: "None",
                value: "none",
              },
              {
                label: "GoLocal",
                value: "golocal",
              },
              {
                label: "G5",
                value: "g5",
              },
              {
                label: "StoragePug",
                value: "storagepug",
              },
              {
                label: "StorEdge",
                value: "storedge",
              },
              {
                label: "Mariposa",
                value: "mariposa",
              },
              {
                label: "Automatit",
                value: "automatit",
              },
              {
                label: "Storagely",
                value: "storagely",
              },
            ]}
          />
          <InputRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.WebsiteProvider, "storagely")}
            keyName={LocationVarKey.StoragelyClientID}
            label="Storagely Client ID"
          />
          <InputRow
            {...page}
            hideIf={IS_NOT_EQUAL(LocationVarKey.WebsiteProvider, "storagepug")}
            keyName={LocationVarKey.StoragePugSingleLocationBaseURL}
            label="StoragePug Single Location URL (everything before /view-unit...)"
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Organization Settings (less common) </SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <DropdownRow
            {...page}
            label="Notification for Every Chat"
            marginTop
            keyName={LocationVarKey.WantsNewChatNotifications}
            options={[
              { label: "No", value: "0" },
              { label: "Email only", value: "email" },
              { label: "SMS only", value: "sms" },
              { label: "Both", value: "both" },
            ]}
          />
          <SwitchRow {...page} keyName={LocationVarKey.LeadEnableDuplicates} label="Enable Duplicate Leads" />
          <SwitchRow {...page} keyName={LocationVarKey.TwoUnhandledBeforeEscalation} label="Two Unhandled Before Escalation" />
          <SwitchRow {...page} keyName={LocationVarKey.WantsProfanityEscalation} label="Escalate on Profanity" />
          <SwitchRow {...page} keyName={LocationVarKey.HasSingleLocation} label="Single Location Operator" />
          <SwitchRow {...page} keyName={LocationVarKey.WantsOneMenuView} label="One Menu View" />
          <SwitchRow {...page} keyName={LocationVarKey.HasValueBasedPricing} label="Value Based Pricing" />
          <SwitchRow {...page} keyName={LocationVarKey.LLMHasABTestAgents} label="A/B Test Agents (if agents enabled)" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.WantsClearStoreVariables} label="Clear Store Variables on Welcome Back" />
          <SwitchRow {...page} keyName={LocationVarKey.ShowSizeDescriptions} label="Show Size Descriptions Worksheet" />
          <SwitchRow {...page} keyName={LocationVarKey.dontUseURLToSetStore} label="Do Not Use URL to Set Facility ID" />
          <SwitchRow {...page} keyName={LocationVarKey.VarySettings} label="Variables Used in Company Information or Important URLs" />
          <Indent {...page}>
            <SwitchRow
              {...page}
              keyName={LocationVarKey.VariesLoginURL}
              label="Account Login URL"
              hideIf={IS_NOT_EQUAL(LocationVarKey.VarySettings, "1")}
            />
            <SwitchRow
              {...page}
              keyName={LocationVarKey.VariesPayOnlineURL}
              label="Pay Online URL"
              hideIf={IS_NOT_EQUAL(LocationVarKey.VarySettings, "1")}
            />
            <SwitchRow
              {...page}
              keyName={LocationVarKey.VariesSizeVisualsURL}
              label="Size Visuals URL"
              hideIf={IS_NOT_EQUAL(LocationVarKey.VarySettings, "1")}
            />
          </Indent>
          <InputRow
            {...page}
            keyName={LocationVarKey.LeadUnitId}
            label="Lead Unit"
          />
          <InputRow
            {...page}
            keyName={LocationVarKey.OnlyShowUnitDimensions}
            label="Only Show Unit Dimensions"
          />

          <DropdownRow
            {...page}
            marginTop
            label="Add Lead To Abandoned Cart Sequence Strategy"
            keyName={LocationVarKey.AddLeadToAbandonedCartSequenceStrategy}
            options={[
              {
                label: "None",
                value: "",
              },
              {
                label: "Origination is Lead",
                value: FMSLeadAddToAbandonedCartSequenceStrategy.ORIGINATION_IS_LEAD,
              }
            ]}
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Getting Started</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.GSGettingStartedCompleted} label="Getting Started Completed" />
          <SwitchRow {...page} keyName={LocationVarKey.GSKickOffMilestoneCompleted} label="Kick Off Tasks Completed" />
          <SwitchRow {...page} keyName={LocationVarKey.GSMilestone1Completed} label="Milestone 1 Tasks Completed" />
        </WorksheetColumn>
        <WorksheetColumn>
          <SwitchRow {...page} keyName={LocationVarKey.GSMilestone2Completed} label="Milestone 2 Tasks Completed" />
          <SwitchRow {...page} keyName={LocationVarKey.GSPostLaunchCompleted} label="Post-Launch Tasks Completed" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> In-Chat After Navigate Quest Slugs</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>

          <QuestDropdownRow {...page} keyName={LocationVarKey.AfterNavigateSizeVisualsQuestSlug} label="Size Visuals Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateShowInventoryQuestSlug} label="Show Inventory Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginAutopayQuestSlug} label="Auto Pay Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginPayBillQuestSlug} label="Pay Bill Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginPasswordQuestSlug} label="Password Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginUsernameQuestSlug} label="Username Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginCreateLoginQuestSlug} label="Create Login Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginCreditDebitQuestSlug} label="CreditDebit Quest Slug" />
        </WorksheetColumn>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginReservationsQuestSlug} label="Reservations Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginUpdateBillingQuestSlug} label="Update Billing Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginUpdateContactQuestSlug} label="Update Contact Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateCareersQuestSlug} label="Career Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateInsuranceQuestSlug} label="Insurance Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAuctionQuestSlug} label="Auction Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateReferralQuestSlug} label="Referral Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateAccountLoginCancelServiceQuestSlug} label="Cancel Service Quest Slug" />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> SMS After Navigate Quest Slugs</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSShowInventoryQuestSlug} label="SMS Show Inventory Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSPayBillQuestSlug} label="SMS Pay Bill Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAuctionQuestSlug} label="SMS Auction Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSSizeVisualsQuestSlug} label="SMS Size Visuals Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSReferralQuestSlug} label="SMS Referral Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSCareerQuestSlug} label="SMS Career Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSInsuranceQuestSlug} label="SMS Insurance Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAboutQuestSlug} label="SMS About Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSCreditDebitQuestSlug} label="SMS CreditDebit Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAutoPayQuestSlug} label="SMS Auto Pay Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSPasswordQuestSlug} label="SMS Password Quest Slug" />
        </WorksheetColumn>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSUpdateBillingQuestSlug} label="SMS Update Billing Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSCreateLoginQuestSlug} label="SMS Create Login Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSUsernameQuestSlug} label="SMS Username Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSReservationsQuestSlug} label="SMS Reservations Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAccountPayBillQuestSlug} label="SMS Account - Pay Bill Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSUpdateContactQuestSlug} label="SMS Update Contact Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSAccountLoginQuestSlug} label="SMS Account Login Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.AfterNavigateSMSSelectStoreQuestSlug} label="SMS SELECT Store Quest Slug" />
          <InputRow
            {...page}
            keyName={LocationVarKey.AfterNavigateSMSAccountLoginCancelServiceQuestSlug}
            label="SMS Account - Cancel Service Quest Slug"
          />
        </WorksheetColumn>
      </WorksheetRow>

      <SectionHeader {...page}> Spot After Navigate Quest Slugs</SectionHeader>
      <WorksheetRow>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.SpotAccessCodeQuestSlug} label="Intent: Get Help Access Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.SpotReviewQuestSlug} label="Intent: Give Feedback Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.SpotPayBillOnlineQuestSlug} label="URL: Online Bill Pay Quest Slug" />
        </WorksheetColumn>
        <WorksheetColumn>
          <InputRow {...page} keyName={LocationVarKey.SpotPayBillPhoneQuestSlug} label="SF: Pay By Phone Quest Slug" />
          <InputRow {...page} keyName={LocationVarKey.SpotManageAccountQuestSlug} label="Intent: Manage Account Quest Slug" />
        </WorksheetColumn>
      </WorksheetRow>
    </>
  );
}
